/**
 * Server clock as seen from this browser.
 *
 * Transfer events carry the server's time (`at`). Comparing that with the
 * browser clock breaks on a salon PC whose clock runs ahead or behind: a
 * banner could be dropped as "too old" or never expire. Every `ready` frame of
 * the live stream carries `server_time`; the offset measured there turns
 * `Date.now()` into server time for all age/expiry decisions.
 */
let offsetMs = 0;

/** Record the server time from a `ready` frame (ignored when unparsable). */
export function setServerTime(serverIso: unknown, localNow: number = Date.now()): void {
  if (typeof serverIso !== 'string') return;
  const t = Date.parse(serverIso);
  if (Number.isNaN(t)) return;
  offsetMs = t - localNow;
}

/** Current time on the server's clock (ms since epoch). */
export function serverNow(localNow: number = Date.now()): number {
  return localNow + offsetMs;
}

/** Offset in ms (server minus browser); exposed for tests and diagnostics. */
export function serverClockOffset(): number {
  return offsetMs;
}

export function resetServerClock(): void {
  offsetMs = 0;
}
